import {
  AuthFormInputSpan2,
  Body,
  Cell,
  CellTitle,
  CellValue,
  Footer,
  FormButton2,
  FormButtonCancel3,
  Row,
  Title,
} from "./styles-step2";
import { ContainerRow } from "../../../components/Container";
import {
  errorView,
  formatCurrency,
  postWithdrawConfirm,
  postWithdrawSendCode,
} from "../../../services/app";
import React, { useEffect, useState } from "react";
import { useApp } from "../../../contexts";
import {
  InfoIcon,
  InfoTooltipIcon,
  TooltipView,
  WalletDetailNotify,
} from "../../wallet-detail/styles";
import { AuthFormInput } from "../../auth/styles";
import { Form } from "antd";
import produce from "immer";
import { InputOtp } from "../../../components/TwoFA/style";
import FormInput from "../../../components/FormCustom2/Input";
import styled from "styled-components";

const InputOtpWraper = styled.div`
  position: relative;
  flex: 1;
  & input {
    padding-right: 110px;
  }
`;

export default function WithDrawSOTStep2(props) {
  const { T, currencies, setLoading, setAlert, isUserSocial, user, getCurrency } = useApp();
  const onClose = props.onBack;
  const [row, setRow] = useState({ ...(props.value || {}) });
  const [sentOtp, setSentOtp] = useState(0);
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [twoFa, setTwoFa] = useState("");
  const [editAble, setEditAble] = useState(false);
  const [errors, setErrors] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    const timer = setInterval(() => {
      setSentOtp((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        return prevState;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const getNameByCode = (code) => {
    return (currencies || []).find((item) => item.code === code)?.name || "";
  };

  const onSentOtp = async () => {
    setLoading(true);
    const result = await postWithdrawSendCode(row.id);
    if (result.status === 200) {
      setSentOtp(180);
    } else {
      setErrors(result?.data?.error?.validates || []);
    }
    setLoading(false);
  };

  const onSubmit = async () => {
    setLoading(true);
    const result = await postWithdrawConfirm({
      transactionId: row?.id,
      destWalletAddress: row?.dest_wallet_address || "",
      password: !isUserSocial ? password : undefined,
      verificationCode: otp,
      twofaCode: !!row?.is_twofa ? twoFa : undefined,
    });
    if (result.status === 200) {
      onClose("success");
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        setAlert({
          type: "error",
          text:
            result?.data?.error?.message ||
            T("Failed to create a withdrawal request"),
        });
      }
    }
    setLoading(false);
  };
  const splitText = (text) => {
    let item = text;
    const splitFont = 22
    const splitEnd = 5
    const numDot = 3
    if (item.length >= splitFont + 8) {
      item = item.substring(0, splitFont);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }
    return item;
  };
  return (
    <Form form={form} className="form-sot-step2">
      {row ? (
        <Body>
          <div className="lg:px-[12px] mb-[28px]">
            <div className="row-item mb-[10px]">
              <div className="text-[#818181] font-semibold font-base ">{T("Transaction ID")}</div>
              <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[8px]">{row?.id}</div>
            </div>
            <div className="row-item">
              <div className="text-[#818181] font-semibold font-base ">{T("Select token")}</div>
              <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[8px]">
                {T(getNameByCode(row?.dest_currency_code))} (
                  {row?.dest_currency_code || ""})
              </div>
            </div>
          </div>
          <WalletDetailNotify
            className="withdrawal-sot"
            style={{
              marginTop: 0,
              background: "#F5AA194D",
              borderRadius: 10,
            }}
          >
            <div className="w-full flex">
              <InfoIcon />
              <div
                className="lg:text-[16px] text-[14px]"
                dangerouslySetInnerHTML={{
                  __html: T("withdraw.confirm_network").replace(
                    "{coin_name}",
                    `<b>Polygon</b>`
                  ),
                }}
              ></div>
            </div>
            <div className="w-full flex">
              <InfoIcon />
              <div
                className="lg:text-[16px] text-[14px]"
                dangerouslySetInnerHTML={{
                  __html: T("withdraw.confirm2"),
                }}
              ></div>
            </div>
          </WalletDetailNotify>
          <div className="lg:px-[12px] mt-[28px]">
            <div className="row-item mb-[10px]">
              <div className="text-[#818181] font-semibold font-base ">{T("Recipient’s Address")}</div>
              <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[8px] flex flex-col lg:flex-row lg:justify-between lg:items-center">
                <span className="hidden lg:block">{row?.dest_wallet_address || ""}</span>
                <span className="block lg:hidden">{splitText(row?.dest_wallet_address || "")}</span>
                <div
                  className="text-[#F3850F] text-[14px]"
                  onClick={() => {
                      onClose("");
                  }}>
                  {T("Want to change?")}
                  </div>
              </div>
            </div>
            <div className="row-item mb-[10px]">
              <div className="text-[#818181] font-semibold font-base ">{T("Sent amount")}</div>
              <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[8px]">
                {formatCurrency(row?.amount || "", null, getCurrency())}{" "}
                {row?.dest_currency_code || ""}
              </div>
            </div>
            <div className="row-item mb-[10px]">
              <div className="text-[#818181] font-semibold font-base ">{T("Fee")}</div>
              <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[8px]">
                  { row?.fee_amount > 0 ? formatCurrency(row?.fee_amount || "", null, getCurrency()) + " " + (row?.dest_currency_code || '') : T('Free')}
              </div>
            </div>
            {!isUserSocial ? (
              <div className="row-item  mt-[24px]">
                <div className="text-[#818181] font-semibold font-base flex justify-start items-center gap-[2px]">{T("Confirm Password")}
                  <TooltipView
                      color={"#EAF2FF"}
                      overlayClassName={"note-tooltip-custom"}
                      title={T(
                        "Please enter the password that you use for Art Walk mobile app and ams.aiavatar.fun"
                      )}
                    >
                      <InfoTooltipIcon style={{ marginLeft: 9 }} />
                  </TooltipView>
                  </div>
                <div className="text-black font-normal text-base">
                <Form.Item
                  {...errorView(errors, "password")}
                  name={"password"}
                  style={{
                    width: "100%",
                    marginTop: 5,
                  }}
                >
                  <FormInput
                    className="input-sot"
                    type="password"
                    value={password}
                    style={{ marginBottom: 0}}
                    maxLength={6}
                    onChange={(event) => {
                      setPassword(event.target.value);
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex(
                              (item) => item.key === "password"
                            ),
                            1
                          );
                        })
                      );
                    }}
                    placeholder={T("Enter your password")}
                  />
                </Form.Item>
                </div>
              </div>
            ) : null}
            <div className="row-item">
              <div className="text-[#818181] font-semibold font-base flex justify-start items-center gap-[2px]">{T("Enter Email Verification Code")}</div>
              <div className="text-black font-normal text-base">
              <InputOtpWraper>
                <Form.Item
                  {...errorView(errors, "verificationCode")}
                  name={"otp"}
                  style={{
                    width: "100%",
                    marginTop: 5,
                  }}
                >
                  <FormInput
                    value={otp}
                    className="input-sot"
                    onChange={(event) => {
                      setOtp(event.target.value);
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex(
                              (item) => item.key === "verificationCode"
                            ),
                            1
                          );
                        })
                      );
                    }}
                    readOnly={sentOtp <= 0}
                    placeholder={
                      sentOtp <= 0
                        ? T("Click “Send Code”")
                        : T("Enter Email Verification Code")
                    }
                  />
                </Form.Item>
                <AuthFormInputSpan2
                  className={"send-code text-aia-red absolute"}
                  style={{ top: 14, right: 12 }}
                  onClick={() => {
                    if (sentOtp <= 0) {
                      onSentOtp().then();
                    }
                  }}
                >
                  {sentOtp > 0 ? `${sentOtp}s` : T("Send Code")}
                </AuthFormInputSpan2>
              </InputOtpWraper>
              </div>
            </div>
            {!!row?.is_twofa || !!user?.is_twofa? (
              <div className="row-item mb-[10px]">
                <div className="text-[#818181] font-semibold font-base flex justify-start items-center gap-[2px]">{T("Enter 2FA code2")}</div>
                <div className="text-black font-normal text-base">
                  <Form.Item
                    {...errorView(errors, "twofaCode")}
                    name={"twofaCode"}
                    style={{
                      width: "100%",
                      marginTop: 5,
                    }}
                  >
                    <FormInput
                      value={otp}
                      maxLength="6"
                      className="input-sot"
                      onChange={(event) => {
                        setOtp(event.target.value);
                        setErrors(
                          produce((draft) => {
                            draft.splice(
                              draft.findIndex(
                                (item) => item.key === "twofaCode"
                              ),
                              1
                            );
                          })
                        );
                      }}
                      placeholder={T("Enter 2FA code2")}
                    />
                  </Form.Item>
                </div>
              </div>
            ) : null}
          </div>
        </Body>
      ) : null}
      <Footer style={{ marginTop: 24, marginLeft: 12, marginRight: 12 }}>
        <ContainerRow>
          <FormButtonCancel3
            style={{ marginRight: 8 }}
            onClick={() => onClose()}
          >
            {T("Cancel")}
          </FormButtonCancel3>
          <FormButton2
            disabled={
              !(
                !!row.dest_wallet_address &&
                !!otp &&
                ((!isUserSocial && !!password) || isUserSocial)
              )
            }
            style={{ marginLeft: 8 }}
            onClick={() => onSubmit()}
          >
            {T("Withdraw")}
          </FormButton2>
        </ContainerRow>
      </Footer>
    </Form>
  );
}
